export const API_RESPONSE = {
  SUCCESS: 200, // 成功

  BAD_REQUEST: 400, // 錯誤的請求
  UNAUTHORIZED: 401, // 未授權
  FORBIDDEN: 403, // 使用者無存取權限

  INTERNAL_SERVER_ERROR: 500, // 伺服器內部錯誤

  UNDEFINED_ERROR: 999, // 未明確定義之錯誤
};

// ERROR_CODES is a collection of constants that store all the code represent error
export const ERROR_CODES = [API_RESPONSE.INTERNAL_SERVER_ERROR];

// HTTP_STATUS is a collection of constants that store all the http status code
export const HTTP_STATUS = {
  OK: 200,
  NOT_FOUND: 404,
};

/** HTTP_METHOD is a collection of constants that store all the http methods */
export const HTTP_METHOD = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
};

/** CODE_TIMEOUT is a constant that represent the error of api timeout */
export const CODE_TIMEOUT = 'ECONNABORTED';

/** UNKNOWN_ERROR is a constant that represent any unknown error */
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';
